import { render } from "./couponImage.vue?vue&type=template&id=184786e4&scoped=true"
import script from "./couponImage.vue?vue&type=script&lang=js"
export * from "./couponImage.vue?vue&type=script&lang=js"

import "./couponImage.vue?vue&type=style&index=0&id=184786e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184786e4"]])

export default __exports__